/**
 * External dependencies.
 */
import { has, isEmpty } from 'lodash';

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

function styling( props, selector = '' ) {
	const { blockAdvanceOptions, blockClientId } = props.attributes;
	selector = selector ? selector : `.gutenify-section-${ blockClientId }.wp-block-gutenify-wc-product-list`;

	let css = '';

	// Item style.
	const innerBlockSelector = `${ selector } .gutenify--wc-product-list-item-inner-wrapper`;

	let innerStyleVars = `${ has( blockAdvanceOptions, 'innerBlock.textColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.textColor ) ? `color: ${ blockAdvanceOptions.innerBlock.textColor };` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.borderColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderColor ) ? `border-color: ${ blockAdvanceOptions.innerBlock.borderColor };` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.borderWidth' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderWidth ) ? `border-width: ${ blockAdvanceOptions.innerBlock.borderWidth }px;` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.borderWidth' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderWidth ) ? `border-style: solid;` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.borderRadius' ) && ! isEmpty( blockAdvanceOptions.innerBlock.borderRadius ) ? `border-radius: ${ blockAdvanceOptions.innerBlock.borderRadius };` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.backgroundColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.backgroundColor ) ? `background: ${ blockAdvanceOptions.innerBlock.backgroundColor };` : '' }`;
	innerStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.backgroundGradient' ) && ! isEmpty( blockAdvanceOptions.innerBlock.backgroundGradient ) ? `background: ${ blockAdvanceOptions.innerBlock.backgroundGradient };` : '' }`;

	// Hover
	let innerHoverStyleVars = `${ has( blockAdvanceOptions, 'innerBlock.hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverTextColor ) ? `color: ${ blockAdvanceOptions.innerBlock.hoverTextColor };` : '' }`;
	innerHoverStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverBackgroundColor ) ? `background: ${ blockAdvanceOptions.innerBlock.hoverBackgroundColor };` : '' }`;
	innerHoverStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverBackgroundGradient ) ? `background: ${ blockAdvanceOptions.innerBlock.hoverBackgroundGradient };` : '' }`;
	innerHoverStyleVars += `${ has( blockAdvanceOptions, 'innerBlock.hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.innerBlock.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.innerBlock.hoverBorderColor };` : '' }`;

	if ( innerStyleVars ) {
		css += `${ innerBlockSelector } { ${ innerStyleVars } }`;
	}
	if ( innerHoverStyleVars ) {
		css += `${ innerBlockSelector }:hover { ${ innerHoverStyleVars } }`;
	}

	return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, css, props );
}

export default styling;

